import { BLUE, GREEN } from '../constants/colors';
import { STEPS } from '../constants/formConfig';

export default function ProgressStepper({current}){
  return(
    <div style={{marginBottom:28}}>
      <div style={{display:"flex",alignItems:"center",marginBottom:16}}>
        {STEPS.map((s,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",flex:1}}>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",flex:1}}>
              <div style={{width:36,height:36,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:13,fontFamily:"sans-serif",transition:"all 0.3s",background:i<current?BLUE:i===current?BLUE:"#E2E8F0",color:i<=current?"#fff":"#94a3b8",boxShadow:i===current?`0 0 0 4px ${BLUE}25`:"none",flexShrink:0}}>
                {i<current?"✓":i+1}
              </div>
              <span className="m-step-lbl" style={{fontSize:10,marginTop:6,fontFamily:"sans-serif",fontWeight:i<=current?700:400,color:i===current?BLUE:i<current?"#475569":"#94a3b8",textAlign:"center",lineHeight:1.2,maxWidth:86}}>{s}</span>
            </div>
            {i<STEPS.length-1&&<div style={{height:2,flex:1,background:i<current?BLUE:"#E2E8F0",borderRadius:99,marginBottom:22,transition:"background 0.4s",flexShrink:0}}/>}
          </div>
        ))}
      </div>
    </div>
  );
}
